// 26. 6. 26 - Footer 언어 선택기 커스텀
  document.querySelectorAll('.footer .b7-localization__button').forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      const b7Language = this.closest('.b7-localization')
        .querySelector('.b7-localization__list-wrap');

      b7Language.classList.toggle('open');
    });
  });
  // ESC 키 누르면 닫기
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.b7-localization__list-wrap.open').forEach((list) => {
        list.classList.remove('open');
      });
    }
  });
  // 바깥 클릭하면 닫기
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.b7-localization').forEach((item) => {
      if (!item.contains(e.target)) {
        item.querySelector('.b7-localization__list-wrap')?.classList.remove('open');
      }
    });
  });